export default [
  {
    path: '/artists',
    name: 'artists',
    component: () => import('../../views/artists/artists.vue'),
    meta: {
      pageTitle: 'Artists',
      breadcrumbs: ['Artists'],
    },
    children: [
      {
        path: '',
        name: 'artists-list',
        component: () => import('../../views/artists/list.vue')
      },
      {
        path: 'create',
        name: 'artists-create',
        component: () => import('../../views/artists/create.vue'),
        meta: {
          pageTitle: 'Create Artist',
          breadcrumbs: ['Artists', 'Create'],
        }
      },
      {
        path: ':id/edit',
        name: 'artists-edit',
        component: () => import('../../views/artists/edit.vue'),
        meta: {
          pageTitle: 'Edit Artist',
          breadcrumbs: ['Artists', 'Edit'],
        }
      }
    ]
  }
]
